import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { ConsumerDefault } from "./../../../context/Provider";
import ProgressBar from "../../../components/ProgressBar";
import "./style.scss";

//host
class LayoutSteps extends Component {
  //navegação
  redirectTo = redirectTo => {
    this.props.history.push(`/${redirectTo}`);
  };

  render() {
    const { renderButtom, className, children } = this.props;

    return (
      <>
        <ConsumerDefault>
          {props => {
            return <ProgressBar {...props} />;
          }}
        </ConsumerDefault>

        <div className={`layoutSteps ${className ? className : ""}`}>
          {children}
          <div className="wrapper-buttons">{renderButtom()}</div>
        </div>
      </>
    );
  }
}

LayoutSteps.defaultProps = {};

export default withRouter(LayoutSteps);
